import React from "react";

// s4n
import ContextProductIndex from './index';
import { client } from './../../../apollo/client'
import graphqlQuery from "./../../../model/apollo/product-index-filtered"
import injectData from './../../../utils/ReactComponent/injectData'
import ImageUtils from './../../../utils/gatsby/image'

// URL Search Params 
import _ from 'lodash'
import { globalHistory } from '@reach/router';
// import navigateTo from 'gatsby'
// import { navigateTo } from 'gatsby-plugin-intl'
import { navigate } from 'gatsby-plugin-intl'



class ComponentClass extends React.Component {

    constructor(props) {
        super(props);

        const { intl, pageContext, 
// images, 
        } = props;

        this.querySign = `?`;
// this.images = images;
this.images = [];

        // console.log(this.getSearchParamValueByKey(`limit`))

        this.filtersInitial = {
            // GraphQL
            category: `` === pageContext.category ? [] : [pageContext.category], // @see: gatsby-node.js
            sort: {id: `title_ASC`, field: `title`, direction: `ASC`},
            limit: pageContext.limit,
            offset: pageContext.skip,
            // Custom
            field_filter_narzedzia: [],
            field_filter_role_zawodowe: [],
        };

        this.state = {
            filters: {
                // GraphQL
                // filter: {
                //     langcode: intl.locale,
                // },
                category: this.getFiltersInitial(`category`), // @see: gatsby-node.js
                sort: this.getSearchParamValueByKey(`sort`) || this.getFiltersInitial(`sort`),
                limit: this.getSearchParamValueByKey(`limit`) || this.getFiltersInitial(`limit`),
                offset: this.getSearchParamValueByKey(`offset`) || this.getFiltersInitial(`offset`),
                // Custom
                field_filter_narzedzia: this.getSearchParamValueByKey(`field_filter_narzedzia`) || this.getFiltersInitial(`field_filter_narzedzia`),
                field_filter_role_zawodowe: this.getSearchParamValueByKey(`field_filter_role_zawodowe`) || this.getFiltersInitial(`field_filter_role_zawodowe`),
            },
            data: {
                loading: false,
                error: false,
                queryResult: null,
            },
            // paginator: {
            //     pageCount: null,
            //     currentPage: 0,
            // }
        }
    }

    getFiltersInitial = (key = null) => {
        if (null !== key) {
            return this.filtersInitial[key] ? this.filtersInitial[key] : null;
        }

        return this.filtersInitial;
    }

    // Search as soon as component is mounted and has query search params!
    componentDidMount() {
        // console.log(`wrapper-class.js: componentDidMount`);

        let query = this.getParams();
        // console.log(query)

        if (!_.isEmpty(query)) {
            this.updateFilters(query, true);
        }
    }

    // componentDidUpdate() {
    //     // console.log(`wrapper-class.js: componentDidUpdate`);
    // }

    /**
     * When we have set url filters and we want to switch to standardk category link - we should reset filters?!
     * 
     * @param {*} nextProps 
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        // console.log(`wrapper-class.js: UNSAFE_componentWillReceiveProps`);

        // if (nextProps.query !== this.props.query) {
        //     this.setState({ query: nextProps.query });
        //     return this.searchRepositories(nextProps.query);
        // }

        let query = this.getParams();
        // console.log(query)

        if (_.isEmpty(query)) {
            query = this.filtersInitial;
            this.updateFilters(query, true);
        }
    }

    updateFilters = async (updatedFilters, isComponentDidMountContext = false) => {

        // /**
        //  * We remove unset/empty because we will merge array with default and if filter was not set we want to use deafault filter values!
        //  */
        // // Remove blank/undefined/empty attributes from an Object in Javascript
        // // @see: https://stackoverflow.com/questions/286141/remove-blank-attributes-from-an-object-in-javascript
        // Object.keys(payload).forEach((key) => (payload[key] == null || payload[key].length == 0) && delete payload[key]);
        // console.log(payload);

        // Object.keys(payload).forEach((key) => {
        //     if (_.isEmpty(payload[key]) && `undefined` !== typeof this.pageContext[key] && this.pageContext[key]) {
        //         payload[key] = this.pageContext[key];
        //     }
        // });

        // Reset offset when changed filter and not set offset from paginator!!!
        // if (typeof updatedFilters.offset === `undefined`) {
        //     updatedFilters.offset = 0;
        // }


        // THIS DOES NOT WORK!!!
        // this.setState({
        //     filters: {
        //         ...this.state.filters,
        //         ...updatedFilters,
        //     }
        // });

        // const filters = {...this.state.filters};

        // THIS DOES WORK!!!
        // const newFilters = {
        //     ...this.state.filters,
        //     ...updatedFilters,
        // };

// console.log(updatedFilters)

        // THIS DOES WORK!!!
        await this.setState((prevState, props) => ({
            filters: {
                ...prevState.filters,
                ...updatedFilters,
            }
        }));

// const filters = {...this.state.filters};
// console.log(this.state.filters)

        !isComponentDidMountContext && this.updateQueryParams();
        
        this.getFilteredResults();
    }

    getSearchParamValueByKey = (key) => {
        const params = this.getParams();
        // return params[key];
        return params[key] ? params[key] : false;
    }

    getSearchParams = () => {
        let searchParams = null;

        if (`?` === this.querySign) {
            searchParams = globalHistory.location.search; // ...?a=b
        }
        if (`#` === this.querySign) {
            searchParams = globalHistory.location.hash; // ...#a=b
            searchParams = searchParams.replace(`#`, `?`) // URLSearchParams handles only "?" ?
        }

        return searchParams;
    }

    /**
     * Decode params and preserve initial types!!!
     */
    paramsToObject = (entries) => {
        let result = {};
        for (let entry of entries) { // each 'entry' is a [key, value] tupple
            const [key, value] = entry;

            // decode params
            if (value.includes(`,`)) { // a,b => [a, b]
                value = value.split(`,`);
            }

            const entryInitialValue = this.getFiltersInitial(key);

            if (`sort` === key) {
                const [field, direction] = value;
                value = {
                    id: `${field}_${direction}`,
                    field,
                    direction,
                };
            } 
            else if (entryInitialValue && Array.isArray(entryInitialValue) && !Array.isArray(value)) { // decode all Array type params!!!
                value = [value];
            }

            result[key] = value;
        }
        
        return result;
    }

    /**
     * Get params from the URL and converts them to Object
     * @see: https://stackoverflow.com/questions/8648892/convert-url-parameters-to-a-javascript-object
     */
    getParams = (searchParams = null) => {
        // console.log(`globalHistory.location: `, globalHistory.location) // hash: "#category=Egzaminy&sort=title%2CASC&limit=12&offset=0&field_filter_role_zawodowe=manager%2Cmanager_projektow"

        if (_.isNull(searchParams)) {
            searchParams = this.getSearchParams();
        }

        const urlSearchParams = new URLSearchParams(searchParams); // const urlParams = new URLSearchParams('abc=foo&def=%5Basf%5D&xyz=5');

        // 1st method
        const entries = urlSearchParams.entries(); //returns an iterator of decoded [key,value] tuples
        const params = this.paramsToObject(entries); //{abc:"foo",def:"[asf]",xyz:"5"}

        // 2nd method - no way of nice transformation of params
        // const params = Object.fromEntries(urlSearchParams); // {abc: "foo", def: "[asf]", xyz: "5"}

        return params;
    }

    setParams = (params = {}) => {

// console.log(`setParams: `, params)

        const searchParams = new URLSearchParams();

        for (let key in params) {
            let value = params[key];

            // just do not set this key in url because it will be merged from context param anyway ~ make it "invisible" in url
            if (`category` === key) {
                continue;
            }

            if (
                !_.isEmpty(value) 
                // || parseInt(value) === 0 // let into url params that are === 0, ex. limit, offset
                || [`limit`, `offset`].includes(key) // let into url limit, offset even is they empty meaning === 0
            ) {
            // if (!_.isUndefined(value)) {

                // encode params
                if (`sort` === key) {
                    value = `${value.field},${value.direction}`;
                } 
                // this happens by default
                // else if (value.includes(`,`)) { // [a, b] => a,b
                //     value = value.split(`,`);
                // }

// console.log(`setParams key: value: `, key, value)

                searchParams.set(key, value);
            }
        }

// console.log(`setParams return: `, searchParams.toString())

        return decodeURIComponent(searchParams.toString());
    }

    // getFiltersFromParams = (params) => {
    //     // const urlSearchParams = new URLSearchParams(searchParams); // const urlParams = new URLSearchParams('abc=foo&def=%5Basf%5D&xyz=5');
    //     // // console.log(searchParams)
    //     // const params = Object.fromEntries(urlSearchParams); // {abc: "foo", def: "[asf]", xyz: "5"}

    //     // return params;
    // }

    updateQueryParams = async () => {
        const { intl } = this.props;
        const filters = {...this.state.filters};

// console.log(filters)

        // const url = this.setParams({ query: `test` });
        // const url = setParams(filters);
        // this.props.location.push(`?${url}`);
        // History.push();
        // navigateTo(`?${url}`);

        // console.log(globalHistory);
        const path = globalHistory.location.pathname;
        const hash = globalHistory.location.hash;
        const pathAndHash = path + hash;
        const pathWithoutLangPrefix = path.replace(`/${intl.locale}`, ``);

        // delete filters[`category`];

        const url = this.setParams(filters);
        // console.log(url)
        navigate(`${pathWithoutLangPrefix}${this.querySign}${url}`);

        // const query = this.getParams(url);
        // console.log(query)
    }

    // isSetField = field => typeof field === `undefined` || (field && field.length === 0) ? false : true;
    // isSetField = field => !(_.isUndefined(field) || _.isNull(field));
    isSetField = field => !_.isEmpty(field);

    getFilteredResults = async () => {
        const { intl } = this.props;
        const filters = {...this.state.filters};

// console.log(`getFilteredResults: `, filters)

        await this.setState((prevState, props) => ({
            // filters: {
            //     ...prevState.filters,
            //     ...filters,
            // },
            data: {
                ...prevState.data,
                loading: true,
            },
        }));

        // @see: https://www.drupal.org/docs/8/modules/graphql/fetching-data
        // @see: https://graphql-search-api.readthedocs.io/en/latest/

        // ! Without this additional field in query (language), filtering return strange results, for term "manager" it returns also "manager_hr" result!
        const graphQLLanguageId = intl.locale.toUpperCase();

        const oFilters = {
            filter: {
                conditions: {
                    field: {
                        langcode: `{
                            field: "langcode", 
                            operator: EQUAL, 
                            value: "${intl.locale}",
                        }`,
                        status: `{
                            field: "status", 
                            operator: EQUAL, 
                            value: "1",
                        }`, // for true in GraphQL response
                        title: `{
                            field: "title", 
                            operator: NOT_EQUAL, 
                            value: "SOFT4NET_DO_NOT_DELETE",
                        }`,
                        category: this.isSetField(filters.category) ? `{
                            field: "field_category.entity.name", 
                            operator: IN, 
                            value: ${JSON.stringify(filters.category)}, 
                            language: ${graphQLLanguageId},
                        }` : ``,
                        field_filter_narzedzia: this.isSetField(filters.field_filter_narzedzia) ? `{
                            field: "field_filter_narzedzia", 
                            operator: IN, 
                            value: ${JSON.stringify(filters.field_filter_narzedzia)}, 
                            language: ${graphQLLanguageId},
                        }` : ``,
                        field_filter_role_zawodowe: this.isSetField(filters.field_filter_role_zawodowe) ? `{
                            field: "field_filter_role_zawodowe", 
                            operator: IN, 
                            value: ${JSON.stringify(filters.field_filter_role_zawodowe)}, 
                            language: ${graphQLLanguageId},
                        }` : ``,                   
                    }
                }
            },
            sort: `{field: "${filters.sort.field}", direction: ${filters.sort.direction}}`,
            limit: filters.limit,
            offset: filters.offset,
        };

// console.log(`oFilters: `, oFilters);
        const APOLLO_QUERY = graphqlQuery(oFilters);
// console.log(APOLLO_QUERY.loc.source.body);

        let result = null;
        try {

// !
// ! @see: https://github.com/drupal-graphql/graphql/issues/940
// !

            result = await client.query({query: APOLLO_QUERY}); // {data: {…}, loading: false, networkStatus: 7, stale: false}
            // const { data, loading, error } = await client.query({query: APOLLO_QUERY});
        } catch (error) {
            await this.setState((prevState, props) => ({
                data: {
                    ...prevState.data,
                    error: error,
                }
            }));
        }

        // if (result.loading) {
        //     return <p>Loading...</p>
        // }

        // console.log(result) // === {data: {…}, loading: false, networkStatus: 7, stale: false}
        let resultDataCommerceProductQueryEntities = {};
        if (result.data) {
            resultDataCommerceProductQueryEntities = this.transformStructure(result.data.commerceProductQuery.entities);
        }
        // const pageCount = Math.ceil(result.data.commerceProductQuery.count / filters.limit);

        const queryResult = {
            ...result,
            data: {
                ...result.data,
                commerceProductQuery: {
                    ...result.data.commerceProductQuery,
                    entities: resultDataCommerceProductQueryEntities,
                }
            },
        }

        // We use version with prevState in order to deep merge state!!!
        await this.setState((prevState, props) => ({
            // filters: {
            //     ...prevState.filters,
            //     ...filters,
            // },
            data: {
                ...prevState.data,
                loading: result.loading,
                queryResult: queryResult,
            },
            // paginator: {
            //     ...prevState.paginator,
            //     pageCount: pageCount,
            // },
        }));
    }

    /**
     * Returns structure similar as if it was retreived from Gatsby GraphQL
     * It wraps object with node attribute - { entities { node } } GraphQL paradigm
     * 
     * @todo: Filter if articles are available in Gtasby static graphql database!!!
     */
    transformStructure = (entities) => {

        // console.log(entities)

/*
        // GraphQL response in Drupal Explorer
        {
          "__typename": "CommerceProductDefault",
          "entityBundle": "default",
          "title": "Egzamin poziom zaawansowany Certified International Customer Service Manager (CICSM) - dla posiadaczy certyfikatu CICSP",
          "variations": [
            {
              "entity": null
            },
            {
              "entity": {
                "variationId": 19,
                "sku": "egz cicsm 2",
                "title": "Egzamin poziom zaawansowany Certified International Customer Service Manager (CICSM) - dla osób nie posiadających certyfikatu CICSP - miesiąc",
                "price": {
                  "number": "590.000000",
                  "currencyCode": "USD"
                },
                "field_images": []
              }
            }
          ]
        },
*/

        const transformedStructure = entities.map((entity, index) => {
            // console.log(entity)

            const langcode = entity.langcode.value;
            // delete entity.langcode; // we do not need to remove it it will be overwritten anyway

            const field_category = entity.field_category
                .filter(item => item)
                .map((item, index) => {
                    // console.log(`item: `, item);

                    return {
                        name: item?.entity?.name || ``
                    }
                });
            // delete entity.field_category;

            // Filter out null variations!!! BUG IN DRUPAL COMMERCE OR GraphQL??!!
            const entityVariationsFiltered = entity.variations.filter((variation, index) => {
                return variation.entity;
            });

            const variations = entityVariationsFiltered.map((item, index) => {
                const field_images = item.entity.field_images.map(({ derivative, entity }, index) => {
                    const uuid = entity.entityUuid;
const fluid = ImageUtils.getGatsbyImageDataByUuid(uuid, entity); // against "Rules of Hooks", @see: https://reactjs.org/docs/hooks-overview.html#rules-of-hooks
// const fluid = this.images[uuid][`fluid`];

                    // console.log(fluid)

                    return {
                        derivative,
                        localFile: {
                            childImageSharp: {
                                fluid: fluid,
                            }
                        }
                    }
                });

                // console.log(field_images)

                return {
                    ...item.entity,
                    relationships: {
                        // ...item.entity.relationships,
                        field_images: field_images,
                    }
                }
            });
            // delete entity.variations;

            // console.log(variations)

            return {
                node: {
                    ...entity,
                    langcode,
                    relationships: {
                        field_category,
                        variations,
                    }
                }
            }
        })

        return transformedStructure;
    }

    // updatePaginator = async (updatedPaginator) => {

    //     this.setState((prevState, props) => ({
    //         paginator: {
    //             ...prevState.paginator,
    //             ...updatedPaginator,
    //         }
    //     }));

    //     // await this.getFilteredResults();
    // }

    render () {
        return (
            <ContextProductIndex.Provider value={{
                
                // values
                filters: {
                    ...this.state.filters,
                    // category: this.state.category,
                    // sort: this.state.sort,
                    // limit: this.state.limit,
                    // offset: this.state.offset,
                },
                data: {
                    ...this.state.data,
                    // loading: this.state.data.loading,
                    // error: this.state.data.error,
                    // queryResult: this.state.data.queryResult,
                },
                // paginator: {
                //     ...this.state.paginator,
                //     // pageCount: this.state.pageCount,
                // },

                // methods
                // setStateCallback: this.setStateCallback,
                updateFilters: this.updateFilters,
                getFiltersInitial: this.getFiltersInitial,
                // updatePaginator: this.updatePaginator,
                transformStructure: this.transformStructure,

            }}>
                { this.props.children }
            </ContextProductIndex.Provider>
        )
    }
}

// const queryCallback = () => ImageUtils.getGatsbyImageData()
// export default injectData(ComponentClass, 'images', queryCallback)

export default ComponentClass;